import { AutoCompleteOptionWithValue } from "../types/AutoCompleteOptionWithValue";
import React from "react";
import { LitigationUnion } from "../types/LitigationUnion";
import { isJsonLdCaseOrganization } from "../types/CaseOrganization";
import { isJsonLdPerson } from "../types/Person";
import { isJsonLdAuthority } from "../types/Authority";

export const courtPostalCodeAutoCompleteAdditionalProps = {
  freeSolo: true,
  isOptionEqualToValue: (option: AutoCompleteOptionWithValue, value: AutoCompleteOptionWithValue) =>
    option.value === value.value,
  extractNewValue: (newValue: AutoCompleteOptionWithValue) => (newValue ? newValue.value : null),
  getSelectedValue: (options: AutoCompleteOptionWithValue[], value: AutoCompleteOptionWithValue) =>
    options.find((opt: AutoCompleteOptionWithValue) => opt.value === value) || null,
  getOptionLabel: (option: AutoCompleteOptionWithValue) => {
    return option.value || "";
  },
  renderOption: (props: React.HTMLAttributes<HTMLLIElement>, option: AutoCompleteOptionWithValue) => {
    return option.value !== null ? (
      <li {...props} key={option.value}>
        {option.label}
      </li>
    ) : null;
  },

  options: ({ product }: { product: LitigationUnion }) => {
    let options = [];

    if (isJsonLdCaseOrganization(product.plaintiff)) {
      options.push({
        label: product.plaintiff.organization.address.postalCode + " (Kläger)",
        value: product.plaintiff.organization.address.postalCode,
      });
    }
    if (isJsonLdPerson(product.plaintiff)) {
      options.push({
        label: product.plaintiff.residenceAddress.postalCode + " (Kläger)",
        value: product.plaintiff.residenceAddress.postalCode,
      });
    }
    if (isJsonLdAuthority(product.plaintiff)) {
      options.push({
        label: product.plaintiff.address.postalCode + " (Kläger)",
        value: product.plaintiff.address.postalCode,
      });
    }

    if (isJsonLdCaseOrganization(product.defendant)) {
      options.push({
        label: product.defendant.organization.address.postalCode + " (Beklagter)",
        value: product.defendant.organization.address.postalCode,
      });
    }
    if (isJsonLdPerson(product.defendant)) {
      options.push({
        label: product.defendant.residenceAddress.postalCode + " (Beklagter)",
        value: product.defendant.residenceAddress.postalCode,
      });
    }
    if (isJsonLdAuthority(product.defendant)) {
      options.push({
        label: product.defendant.address.postalCode + " (Beklagter)",
        value: product.defendant.address.postalCode,
      });
    }

    if (product.courtPostalCode && !options.some((option) => option.value === product.courtPostalCode)) {
      options.push({
        label: product.courtPostalCode,
        value: product.courtPostalCode,
      });
    }

    return options;
  },
};
